import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIssueDesc, selectShowInvalids } from '@store/order/selectors';
import { setIssueDesc } from '@store/order/slice';
import { TextArea } from '@components/text-field/TextArea';
import SurgeryDate from '@pages/order/surgery-info/SurgeryDate';
import { invalidFormValue } from '@components/utils';



const SurgeryInfo = () => {
	const { t } = useTranslation('forms');

	const issueDesc = useSelector(selectIssueDesc);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateIssueDesc = (value: string | null) => dispatch(setIssueDesc(value));

	return (
		<div className='surgery-info-section'>

			<TextArea
				label={t('surgeryInfo.segments.sectionLabel')}
				required={true}
				rounded={true}
				maxLength={250}
				description={`(${t('surgeryInfo.info.sectionLabel')})`}
				value={issueDesc ? issueDesc : undefined}
				onChange={(value: string) => !value && value.length === 0 ? updateIssueDesc(null) : updateIssueDesc(value)}
				errorMessage={showInvalids && invalidFormValue(issueDesc) ? t('validation.requiredField') : undefined} />

			<SurgeryDate />

		</div>
	);
};

export default SurgeryInfo;